import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomDialog from "components/CustomDialog";
import TopTab from "components/CustomInput/Tab/TopTab";
import CustomTable from "components/CustomTable";
import VisibilityIcon from '@material-ui/icons/Visibility';
import styled from 'styled-components/macro';
import { SET_COMMENT, GET_CHANGELOG_BY_ID, EXPORT_SUMMARY } from 'store/key';
import useComment from "hooks/useComment";
import ChangeHistoryDialog from "./ChangeHistory/ChangeHIstoryDialog";
import { CommentDialogViewOnly } from "./CommentDialog";
import CustomButton from "components/CustomInput/Button";
import moment from "moment";

const SActionContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    color: #1976d2;
`;

const CommentSummary = ({
    tabs,
    defaultTab,
    formId,
}) => {

    const isShow = useSelector((state) => state.comment.isShowCommentSummary);
    const { allComments, changeLog } = useSelector(state => state.comment);
    const filterTabs = useMemo(() => {
        return tabs?.filter(item => item?.type === 'hospital' || item?.type === 'info')
    }, [tabs]);

    const dispatch = useDispatch();

    const [currentTab, setCurrentTab] = useState(defaultTab);
    const [isShowChangeHistory, setIsShowChangeHistory] = useState(false);
    const [isShowViewOnly, setIsShowViewOnly] = useState(false);
    const [currentRows, setCurrentRows] = useState([]);
    const [viewComment, setViewComment] = useState([]);
    
    useEffect(() => {
        if (currentTab?.display === 'Study Info') {
            const res = allComments
                ?.filter(item => item?.studyInfo === 'Y')
                ?.map((item, index) => {
                    const arr = JSON.parse(item.commentContext);
                    const time = arr[arr.length - 1]?.lastUpdated;
                    return { ...item, columnId: index + 1, lastUpdated: moment(time).format('YYYY-MM-DD HH:mm:ss') }
                })
            setCurrentRows(res);
        } else {
            const res = allComments
                ?.filter(item => item?.siteInfo === currentTab?.display)
                ?.map((item, index) => {
                    const arr = JSON.parse(item.commentContext);
                    const time = arr[arr.length - 1]?.lastUpdated;
                    return { ...item, columnId: index + 1, lastUpdated: moment(time).format('YYYY-MM-DD HH:mm:ss') }
                })
            setCurrentRows(res);
        }
    }, [currentTab, allComments])

    const onOK = () => {
        dispatch({
            type: 'SET_COMMENT',
            payload: {
                isShowCommentSummary: false,
            },
        });
    }

    const handleTabButton = (tab) => {
        setCurrentTab(tab);
    }

    const onClickView = (row) => {
        try {
            setViewComment(JSON.parse(row?.commentContext));
        } catch (error) {
            setViewComment([]);
        }
        setIsShowViewOnly(true);
    }

    const onClickChangeHistory = (row) => {
        dispatch({ type: GET_CHANGELOG_BY_ID, payload: row?.id });
        setIsShowChangeHistory(true)
    }

    const columns = [
        { field: 'columnId', headerName: '', width: 50 },
        { field: 'questionDesc', headerName: 'Question', width: 300 },
        { field: 'lastUpdated', headerName: 'Last Comment Time', width: 150 },
        { field: 'commentStatus', headerName: 'Status', width: 100 },
        {
            field: 'action1',
            headerName: '',
            width: 50,
            valueGetter: (params) => {
                return (
                    <SActionContainer onClick={() => onClickView(params?.row)}>
                        <VisibilityIcon />
                        View
                    </SActionContainer>
                )
            },
        },
        {
            field: 'action2',
            headerName: '',
            width: 120,
            valueGetter: (params) => {
                return (
                    <SActionContainer onClick={() => onClickChangeHistory(params?.row)}>
                        <VisibilityIcon />
                        Change history
                    </SActionContainer>
                )
            },
        },
    ];

    useEffect(() => {
        setCurrentTab(defaultTab)
    }, [defaultTab])

    const handleExport = () => { 
        dispatch({ type: EXPORT_SUMMARY, payload: formId });
    }

    return (
        <CustomDialog
            isShow={isShow}
            title="Comment Summary"
            confirmText="Close"
            onConfirm={onOK}
            width={1000}
            maxWidth="lg"
            disableCancelButton
        >
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'row-reverse' }}>
                <CustomButton style={{ position: 'absolute', top: '-20px', right: 0 }} onClick={handleExport} disabled={allComments?.length === 0}>
                    Export
                </CustomButton>
            </div>
            <ChangeHistoryDialog
                isShow={isShowChangeHistory}
                onConfirm={() => setIsShowChangeHistory(false)}
                dataList={changeLog}
            />
            <CommentDialogViewOnly
                isShow={isShowViewOnly}
                maxWidth="sm"
                messages={viewComment}
                onClose={() => setIsShowViewOnly(false)}
            />
            <TopTab
                data={filterTabs}
                value={currentTab.key}
                onClick={handleTabButton}
            />
            <CustomTable
                columns={columns}
                rows={currentRows}
                isSortable={false}
                textAlign="left"
            />
        </CustomDialog>
    );
};

export default CommentSummary;